import React from 'react'
import styles from './Pagination.module.scss'
import { ChevronDoubleRightIcon } from '@heroicons/react/24/solid'
import { ChevronDoubleLeftIcon } from '@heroicons/react/24/solid'

const Pagination = ({ currentPage, totalPages, onPageChange, itemsPerPage = 10 }) => {
	const pageNumbers = []
	const maxVisiblePages = 5

	let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2))
	let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1)

	if (endPage - startPage + 1 < maxVisiblePages) {
		startPage = Math.max(1, endPage - maxVisiblePages + 1)
	}

	for (let i = startPage; i <= endPage; i++) {
		pageNumbers.push(i)
	}

	return (
		<div className={styles.paginationContainer}>
			{currentPage > 1 && (
				<button
					className={`${styles.nextButton}`}
					onClick={() => onPageChange(currentPage - 1)}>
					<ChevronDoubleLeftIcon className={styles.icon} />
				</button>
			)}

			{pageNumbers.map((number) => (
				<button
					key={number}
					className={`${styles.pageButton} ${styles.pageNumber} ${
						currentPage === number ? styles.activePage : ''
					}`}
					onClick={() => onPageChange(number)}>
					{number}
				</button>
			))}

			{currentPage < totalPages && (
				<button
					className={`${styles.nextButton}`}
					onClick={() => onPageChange(currentPage + 1)}>
					<ChevronDoubleRightIcon className={styles.icon} />
				</button>
			)}
		</div>
	)
}

export default Pagination
